module.exports = __webpack_public_path__ + "static/anli4.ed545770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli4.jpg
// module id = 717
// module chunks = 168707334958949